var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-simple-table",
    {
      class: [
        _vm.isTransparent ? "transparent" : "background",
        _vm.hoverTable ? "" : "no-hover-table"
      ],
      attrs: { dense: "" }
    },
    [
      _c(
        "tbody",
        _vm._l(_vm.tableKeys, function(key, index) {
          return _c("tr", { key: key }, [
            _c("td", { staticClass: "caption pa-0 font-weight-bold" }, [
              _c(
                "div",
                {
                  staticClass: "d-flex align-start",
                  staticStyle: { height: "100%" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.generateMessage(`${_vm.i18Path}.${key}`)) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            Array.isArray(_vm.item[key])
              ? _c(
                  "td",
                  {
                    staticClass: "caption pa-0 text-end",
                    class: _vm._f("setClass")(index, _vm.specificClasses)
                  },
                  _vm._l(_vm.item[key], function(value, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _vm._t(
                          "arrayItem",
                          function() {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(value) +
                                  "\n          "
                              )
                            ]
                          },
                          { item: value }
                        )
                      ],
                      2
                    )
                  }),
                  0
                )
              : _c(
                  "td",
                  {
                    staticClass: "caption pa-0 text-end",
                    class: _vm._f("setClass")(index, _vm.specificClasses)
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.format(key, index)) + "\n      "
                    )
                  ]
                )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }